module.exports = __webpack_public_path__ + "static/img/fa5.797c3ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/solution/fa5.png
// module id = FH6S
// module chunks = 3